import type {IPickerItem} from '../types'

/** Concat A (selected) and B (fetched) but showing always all A items
 * (up to maxVisibleSelectedItems) and only the first B items to complete pageSize. */
export function concatAndDedup<T extends IPickerItem>(
  a: T[],
  b: T[],
  pageSize = 100,
  maxVisibleSelectedItems = 500,
): T[] {
  if (a.length >= pageSize) {
    return a.slice(0, maxVisibleSelectedItems)
  }

  const aIds = new Set(a.map(item => item.id))
  const dedupedB = b.filter(item => !aIds.has(item.id))
  return a.concat(dedupedB).slice(0, pageSize)
}
